/**
 * dirty-count-chip.tsx — Phase 049 Plan 03 Task 2 (DRAFT-03 surfaces / D-049-04).
 *
 * Small amber chip rendered in the Preview header chrome when at least one
 * block has at least one truly-different draft cell. Reads `dirtyCount`
 * from `useDraftStore` (the eagerly-computed selector that does the
 * draft-vs-baseline deep compare so type-then-revert never produces a
 * stuck dirty state — SC#3 invariant).
 *
 * Visual contract (CONTEXT D-049-04 Claude's discretion — planner picked
 * amber as a hue distinct from Phase 048 selection (violet) and hover
 * (lighter violet); matches the project's `amber-*` Tailwind precedent):
 *   - bg-amber-100 / text-amber-900 / a small amber-500 dot.
 *   - mounts inside the existing `aboxElementMap != null` chrome gate
 *     (D-048-03 invariant) in `preview-surface.tsx`; on the non-ABox path
 *     this component never renders and the chrome stays byte-identical to
 *     v2.8 Phase 048.
 *   - render-gated additionally on `dirtyCount > 0` internally, so a
 *     freshly-loaded ABox app with no drafts shows zero new chrome.
 *
 * T-049-03-01 (carried T-049-02-03) — XSS via the chip text: `dirtyCount`
 * is a number; 'unsaved' is a literal string; React escapes string children.
 * No `dangerouslySetInnerHTML`.
 */

import { useDraftStore } from '@/features/preview/store/draft-store'

export function DirtyCountChip() {
  const dirtyCount = useDraftStore((s) => s.dirtyCount())
  if (dirtyCount === 0) return null
  return (
    <span
      data-testid="preview-dirty-count-chip"
      className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10.5px] font-medium bg-amber-100 text-amber-900"
    >
      <span
        className="w-1.5 h-1.5 rounded-full bg-amber-500"
        aria-hidden="true"
      />
      {dirtyCount} unsaved
    </span>
  )
}
